import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  }
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h4">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
           <CloseIcon className="close-icon" />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    '& ul': {
      margin: theme.spacing(1,2),
      padding: theme.spacing(1,3),
      'list-style': 'initial',
    }
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    '& button': {
      margin: theme.spacing(1,2),
      padding: theme.spacing(1,3),
    }
  }
}))(MuiDialogActions);

 const Modal = (props) => {
  return (
    <div>
      <Dialog maxWidth={props.maxWidth} onClose={props.onClose} open={props.open}>
        <DialogTitle onClose={props.onClose}>
          {props.title}
        </DialogTitle>
        <DialogContent dividers>
            {props.content}
        </DialogContent>
        <DialogActions>
            {props.actions}
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Modal;